import React from "react";

const Header = (props) => {
  return <a href="/"><div className="bg-header">
          <h1>Mr &infin; Mrs</h1>
        </div></a>;
};

export default Header;